import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useTitle } from "@/app/use-title";
import { useSubscription } from "@/auth/subscription-context";

import { AdcAppFooter } from "./components/footer";
import { AdcAppHeader } from "./components/header";

export const AdcAppShell = () => {
  const { hasAdc, isLoading } = useSubscription();
  useTitle("Alt Data Consensus");

  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);

  if (!isLoading && !hasAdc) return <Navigate to="/no-subscription" replace />;

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <AdcAppHeader />
      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
      <AdcAppFooter />
    </div>
  );
};
